import { render } from "./SearchSvgIcon.vue?vue&type=template&id=ddd03246"
import script from "./SearchSvgIcon.vue?vue&type=script&lang=js"
export * from "./SearchSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__